import { Component, OnInit, Output, EventEmitter, ViewEncapsulation, ElementRef, ViewChild } from "@angular/core";

@Component({
    selector: 'cv-img-crop',
    templateUrl: './img-crop.component.html',
    styleUrls: ['./img-crop.component.scss'],
    encapsulation: ViewEncapsulation.None //allow styling image-cropper
})
export class ImgCropComponent implements OnInit {
    @Output() imgChange = new EventEmitter<string>(); //event emitter that returns the cropped image string

    @ViewChild('candidatePhotoId') candidatePhotoId: ElementRef<HTMLElement>;
    public imgSrc: string = ""; //internally used to hold the base image
    public croppedImage: string = ""; //string that holds the final crop bit string
    public imgEditing: boolean = false; //bool to toggle the select image vs crop view

    constructor(
    ) { }

    //sets up the event listeners to handle the drag, drop, and file inputs
    async ngOnInit() {
    }

    //emits the result when the cropper makes changes
    emitChange(event) {
        this.croppedImage = event.base64;
        this.imgChange.emit(this.croppedImage);
    }

    //used to use a stylized button to activate the html file input
    openFileBrowser(event: MouseEvent) {
        this.candidatePhotoId.nativeElement.click();
        event.stopImmediatePropagation();
    }

    //funciton used to handle the file input event
    uploadFile(e: Event, type: string) {
        e.preventDefault();

        let files;
        if (type == "form") {
            files = (e.target as HTMLInputElement).files;
        }
        else if (type === "drop") {
            files = (e as DragEvent).dataTransfer.files;
        }

        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            if (file.type.indexOf("image") !== -1) {
                this.previewFile(file);
            } else {
                return;
            }
        }
    }

    //function that reads the input file bit string and send it to the crop directive
    previewFile(file: File) {
        let reader: FileReader = new FileReader();

        reader.onload = () => {
            this.imgEditing = true;
            this.imgSrc = reader.result.toString();
        };

        reader.readAsDataURL(file);
    }
}
